import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useIs17Inch } from '../../../../hooks/useBreakPoint';

const SelectBox = ({ searchParams, handleInputChange, flag ,setDesc }) => {

    const [emogList, setEmogList] = useState([]);
    const [grdcList, setGrdcList] = useState([]);
    const [locaList, setLocaList] = useState([]);

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const response = await axios.get('/ptmiapi/listInfo.do');
                setGrdcList(response.data.optionList.grdc || []);
                setLocaList(response.data.optionList.loca || []);
                const response2 = await axios.get('/ptmiapi/emogList.do', {
                    params: {
                        grdc: searchParams.searchGrdc,
                        loca: searchParams.searchLoca
                    }
                });
                setEmogList(response2.data.emogList || []);
            } catch (error) {
                console.error('초기 데이터 로딩 중 오류 발생:', error);
            }
        };
        fetchInitialData();
    }, []);

    const mounted = useRef(false);
    useEffect(() => {
        const fetchHospList = async () => {
            if (!mounted.current) {
                mounted.current = true;
            } else {
                try {
                    const response = await axios.get('/ptmiapi/emogList.do', {
                        params: {
                            grdc: searchParams.searchGrdc,
                            loca: searchParams.searchLoca
                        }
                    });
                    setEmogList(response.data.emogList || []);
                } catch (error) {
                    console.error('병원 목록 로딩 중 오류 발생:', error);
                }
            }
        };
        fetchHospList();
    }, [searchParams.searchEmog, searchParams.searchLoca]);

    useEffect(() => {
        const desc = flag ? emogList.find((a) => a.EMOGCODE === searchParams.searchEmog)?.EMOGDESC : emogList.find((a) => a.emogcode === searchParams.searchEmog)?.emogdesc;
        setDesc(desc);
    }, [searchParams.searchEmog]);

    const is17Inch = useIs17Inch();

    return (
        <>
            <div className='com-search'>
                <table>
                    <colgroup>
                        <col width="9%" />
                        <col width="35%" />
                        <col width="11%" />
                        <col width="29%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>센터구분</th>
                            <td>
                                <select
                                    name='searchGrdc'
                                    className='w-full'
                                    value={searchParams.searchGrdc}
                                    onChange={handleInputChange}
                                    disabled={localStorage.getItem("userAuth") === 'J003'}
                                >
                                    <option value="">전체</option>
                                    {grdcList.map(emog => (
                                        <option key={emog.bscdminr} value={emog.bscdminr}>
                                            {emog.bscddesc}
                                        </option>
                                    ))}
                                </select>
                            </td>
                            <th>지역</th>
                            <td>
                                <select
                                    name='searchLoca'
                                    className='w-full'
                                    value={searchParams.searchLoca}
                                    onChange={handleInputChange}
                                    disabled={localStorage.getItem("userAuth") === 'J003'}
                                >
                                    <option value="">전체</option>
                                    {locaList.map(loca => (
                                        <option key={loca.bscdminr} value={loca.bscdminr}>
                                            {loca.bscddesc}
                                        </option>
                                    ))}
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <th>기관명<span style={{ color: 'red' }}>*</span></th>
                            <td>
                                <select
                                    name='searchEmog'
                                    className='w-full'
                                    value={searchParams.searchEmog}
                                    onChange={handleInputChange}
                                    disabled={localStorage.getItem("userAuth") === 'J003'}
                                >
                                    {localStorage.getItem("userAuth") === 'J003' ?
                                        <option value={localStorage.getItem("useremcd")}>{localStorage.getItem("emogdesc")}</option>
                                        :
                                        <>
                                            <option value="">전체</option>
                                            {emogList.map(hosp => (
                                                <option key={hosp.EMOGCODE || hosp.emogcode} value={hosp.EMOGCODE || hosp.emogcode}>
                                                    {hosp.EMOGDESC || hosp.emogdesc}
                                                </option>
                                            ))}
                                        </>
                                    }
                                </select>
                            </td>
                            <th>
                                <select
                                    id="searchDateCls"
                                    name="searchDateCls"
                                    value={searchParams.searchDateCls}
                                    onChange={handleInputChange}
                                >
                                    <option value="01">내원일시</option>
                                    <option value="02">전송일시</option>
                                </select>
                            </th>
                            <td colSpan={3}>
                                <input
                                    type="date"
                                    name="searchFromdate"
                                    value={searchParams.searchFromdate}
                                    onChange={handleInputChange}
                                    max={searchParams.searchTodate}
                                />
                                &nbsp;~&nbsp;
                                <input
                                    type="date"
                                    name="searchTodate"
                                    value={searchParams.searchTodate}
                                    onChange={handleInputChange}
                                    min={searchParams.searchFromdate}
                                    max={new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0]}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>구분</th>
                            <td>
                                <label style={{ marginRight: '13px' }}>
                                    <input
                                        type="radio"
                                        name="searchGubun"
                                        value=""
                                        checked={searchParams.searchGubun === ''}
                                        onChange={handleInputChange}
                                    />
                                    전체
                                </label>
                                <label style={{ marginRight: '13px' }}>
                                    <input
                                        type="radio"
                                        name="searchGubun"
                                        value="C"
                                        checked={searchParams.searchGubun === 'C'}
                                        onChange={handleInputChange}
                                    />
                                    대상
                                </label>
                                <label style={{ marginRight: '13px' }}>
                                    <input
                                        type="radio"
                                        name="searchGubun"
                                        value="F"
                                        checked={searchParams.searchGubun === 'F'}
                                        onChange={handleInputChange}
                                    />
                                    완료
                                </label>
                                <select
                                    id="searchGubunS"
                                    name="searchGubunS"
                                    value={searchParams.searchGubunS}
                                    onChange={handleInputChange}
                                    className={is17Inch ? 'w-20' : 'w-28'}
                                >
                                    <option value="*">상태 전체</option>
                                    {searchParams.searchGubun !== 'F' && <option value="H">생성</option>}
                                    {searchParams.searchGubun !== 'C' &&
                                        <>
                                            <option value="G">퇴실완료</option>
                                            <option value="B">퇴실재검토필요</option>
                                            <option value="Y">퇴실재검토완료</option>
                                            <option value="S">퇴원완료</option>
                                            <option value="N">퇴원재검토필요</option>
                                            <option value="Z">퇴원재검토완료</option>
                                        </>
                                    }
                                    {searchParams.searchGubun === '' &&
                                        <>
                                            <option value="D">삭제</option>
                                            <option value="E">오류</option>
                                            <option value="C">접수취소</option>
                                        </>
                                    }
                                </select>
                            </td>
                            <th>등록번호</th>
                            <td>
                                <input
                                    type="text"
                                    id="searchIdno"
                                    name="searchIdno"
                                    value={searchParams.searchIdno}
                                    onChange={handleInputChange}
                                    className='w-full'
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </>
    );
};

export default SelectBox; 